var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import DetailsPageHeader from '../DetailsPageHeader';
import HorizontalNav from '../HorizontalNav';
;
const DetailsPage = (_a) => {
    var { breadcrumbs, actionButtons, actionMenu, pageHeading, onTabSelect, tabs = [], defaultActiveKey, children } = _a, props = __rest(_a, ["breadcrumbs", "actionButtons", "actionMenu", "pageHeading", "onTabSelect", "tabs", "defaultActiveKey", "children"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DetailsPageHeader, Object.assign({ breadcrumbs: breadcrumbs, actionButtons: actionButtons, actionMenu: actionMenu, pageHeading: pageHeading }, props)),
        (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 0 ? React.createElement(HorizontalNav, Object.assign({ tabs: tabs, onTabSelect: onTabSelect, defaultActiveKey: defaultActiveKey }, props)) : null,
        children));
};
export default DetailsPage;
